import { variantsFields } from "../fragments";

export default `
  ${variantsFields}
  
  query($userProductsIds: [String!]) {
    variants(userProductsIds: $userProductsIds) {
    variants{
      ...variantsFields
    }
}
  }
`;